const initialState = {
  messages: [],
  // Each toast's id, so one can be dismissed without the others.
  nextId: 1,
}

export default initialState
